import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { createRefPath } from 'global/firestoreData/appData/appRefPaths';
import React, { useContext, useEffect, useState } from 'react'
import { Icon, Popup } from 'semantic-ui-react'
import { renderHtmlXXX } from '../html/renderHtml';

export const PopupHelp = ({ help }) => {

  const { helpType, title, content } = help ?? {}

  const parentContext = useContext(ParentContext);
  const { fns } = parentContext ?? {}
  const { database_fns } = fns

  const [helpSettings, setHelpSettings] = useState({})

  useEffect(() => {
    const cb = (res) => {
      setHelpSettings(res?.helpSettings?.[helpType])
    }
    const _refPath = createRefPath(['help', 'helpSettings'])
    database_fns.get_data({ refPath: _refPath, callback: cb, opts: { ignoreId: true } })
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [helpType]);

  return (
    <Popup
      header={title}
      content={helpSettings ? renderHtmlXXX(helpSettings) : 'No Help Content'}
      on='click'
      size='tiny'
      position='bottom right'
      basic
      style={{ backgroundColor: 'var(--off-black-2', color: 'white', border: '1px solid var(--off-black-3)' }}
      trigger={<Icon circular size='small' inverted color={helpSettings ? 'blue' : 'grey'} name='info' style={{ float: 'right' }} />}
    />
  )
}
